module.exports = __webpack_public_path__ + "img/walking-scout.a34e71d8.svg";